<div class="container mt-4">
    <div class="row">
        <div class="col-12 col-lg-8 offset-lg-2">
            <div class="bg-body-secondary rounded-3 p-3">
                @let headerImage = company()?.headerImage || 'assets/images/surefire-logo.svg';

                <div class="text-center">
                    <img class="mb-4" [src]="headerImage" alt="Surefire Logo" class="img-fluid" />
                </div>

                <div class="row my-4">
                    <div class="order-2 order-md-1 col-md-6 mt-3 text-center text-md-start">
                        <h1 class="text-danger">Payment Cancelled</h1>
                        <p class="fw-bold">No payment has been made, the link you received is valid for 24 hours.</p>
                        <p>Thank you<br />{{ company()?.name }}.</p>
                    </div>
                    <div class="order-1 order-md-2 col-md-6 text-center">
                        <fa-icon class="text-danger" size="10x" [icon]="['fas', 'xmark-circle']"></fa-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
